import { createFeatureSelector, createSelector } from '@ngrx/store'
import { TEAMS_FEATURE_KEY, TeamsState, teamsAdapter } from './teams.reducer'

// Lookup the 'Teams' feature state managed by NgRx
export const selectTeamsState = createFeatureSelector<TeamsState>(TEAMS_FEATURE_KEY)

const { selectAll, selectEntities } = teamsAdapter.getSelectors()

export const selectTeamsLoaded = createSelector(selectTeamsState, (state: TeamsState) => state.loaded)

export const selectTeamsError = createSelector(selectTeamsState, (state: TeamsState) => state.error)

export const selectAllTeams = createSelector(selectTeamsState, (state: TeamsState) => selectAll(state))

export const selectTeamsEntities = createSelector(selectTeamsState, (state: TeamsState) => selectEntities(state))

export const selectSelectedId = createSelector(selectTeamsState, (state: TeamsState) => state.selectedId)

export const selectedTeam = createSelector(selectTeamsEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const getDataView = createSelector(selectTeamsState, (state: TeamsState) => state.dataView)

export const selectSearchHistory = createSelector(selectTeamsState, (state: TeamsState) => state.searchHistory)
export const selectCount = createSelector(selectTeamsState, (state: TeamsState) => state.count)
export const selectEditCreateLoaded = createSelector(selectTeamsState, (state: TeamsState) => state.editCreateLoaded)
